import { Chip } from "@mui/material";

const difficultyColors = {
  Easy: { bg: "#e8f5e9", color: "#2e7d32" },
  Medium: { bg: "#fff3e0", color: "#e65100" },
  Hard: { bg: "#ffebee", color: "#c62828" },
};

const DifficultyChip = ({ difficulty }) => {
  const colors = difficultyColors[difficulty] || difficultyColors.Medium;
  return (
    <Chip
      label={difficulty}
      size="small"
      sx={{
        backgroundColor: colors.bg,
        color: colors.color,
        fontWeight: 600,
        fontSize: "0.75rem",
      }}
    />
  );
};

export default DifficultyChip;
